module.exports = __webpack_public_path__ + "media/scholarships/icon-outlook-772944c1.svg";